import { ADD_ACCOUNT, FETCH_ALL_ACCOUNTS, UPDATE_ACCOUNT_INFO } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate:{}}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_ACCOUNT:
            return { ...state ,data: { ...state.data, [action.payload.id]:action.payload  }}
        case FETCH_ALL_ACCOUNTS:
            return {...state, data:_.mapKeys(action.payload, 'id')}
        case UPDATE_ACCOUNT_INFO:
            return { ...state, data: { ...state.data, [action.payload.id]:action.payload }  }
        default:
            return state;
    }
}